import { Pipe, PipeTransform } from '@angular/core';
import { InstallerPassModel } from '@bo-client/shared/models/installerPassDto';
import {
  InstallerPassStatusEnum,
  InstallerPassStatusType
} from '@bo-client/technician-management/tm-user/tm-user.model';
import { MetaService } from '@bo-client/core/api/meta-service';
import { DatesService } from '@bo-client/shared/dates/dates.service';
import { TmUserService } from '@bo-client/technician-management/tm-user/tm-user.service';
import { AreaTypesModel } from '@bo-client/shared/models/areaTypes';

@Pipe({
  name: 'statusPassProgressPass'
})
export class StatusProgressPipe implements PipeTransform {
  transform(pass: InstallerPassModel) {
    if (!pass) {
      return 0;
    }
    const totalDocs: number = pass.answers.filter((xDoc) => xDoc.docType == 'doc').length;
    const loadedDocs: number = pass.answers.filter(
      (xDoc) => xDoc.attachments[0].url != null && xDoc.docType == 'doc'
    ).length;
    if (loadedDocs == 0) {
      return 0;
    }
    return Math.round((loadedDocs / totalDocs) * 100);
  }
}

@Pipe({
  name: 'statusPassCss'
})
export class StatusPassCssPipe implements PipeTransform {
  constructor(private metaService: MetaService) {
    // Empty
  }

  transform(passStatus: InstallerPassStatusType) {
    if (!passStatus) {
      return '#c9c9c9';
    }
    const passStatusList = this.metaService.getInstallerPassStatus();
    const idxStatus = passStatusList.findIndex((x) => x.value == passStatus);
    if (idxStatus != -1) {
      return passStatusList[idxStatus].cssColor;
    } else {
      return '#c9c9c9';
    }
  }
}

@Pipe({
  name: 'passStatusName'
})
export class PassStatusDisplayPipe implements PipeTransform {
  constructor(
    private datesService: DatesService,
    private tmUserService: TmUserService,
    private metaService: MetaService
  ) {
    // Empty
  }

  transform(passStatus: InstallerPassStatusType, datePassExpired?: Date): string {
    if (!passStatus) {
      return '-';
    }
    const passStatusList = this.metaService.getInstallerPassStatus();
    const idxStatus = passStatusList.findIndex((x) => x.value == passStatus);
    if (idxStatus != -1) {
      if (!!datePassExpired && !this.datesService.dateIsExpired(datePassExpired)) {
        const leftDays = this.tmUserService.calcDaysToRenew(datePassExpired);
        if (leftDays < 60) {
          const plural = leftDays > 1 ? 'en' : '';
          return 'Läuft in ' + leftDays + ' Tag' + plural + ' ab.';
        }
      }
      return passStatusList[idxStatus].displayName;
    } else {
      return '-';
    }
  }
}

@Pipe({
  name: 'passExpired'
})
export class PassExpiredPipe implements PipeTransform {
  constructor(
    private datesService: DatesService,
    private tmUserService: TmUserService,
    private metaService: MetaService
  ) {
    // Empty
  }

  transform(pass: InstallerPassModel, areaTypeList: AreaTypesModel[], daysBefore?: number) {
    if (!pass) {
      return null;
    }
    const passStatusList = this.metaService.getInstallerPassStatus();
    const idxStatus = passStatusList.findIndex((x) => x.value == pass.status);
    const textToDisplay =
      'Der ' +
      areaTypeList.find((y) => y.id == pass.idarea).description +
      '-Ausweis Nummer: ' +
      pass.passNummer;
    if (idxStatus != -1) {
      if (pass.status === InstallerPassStatusEnum.Expired) {
        return textToDisplay + ' ist abgelaufen';
      }
      if (
        pass.status === InstallerPassStatusEnum.Valid &&
        !!pass.expirationdate &&
        !this.datesService.dateIsExpired(pass.expirationdate)
      ) {
        const leftDays = this.tmUserService.calcDaysToRenew(pass.expirationdate);
        if (leftDays < daysBefore) {
          const plural = leftDays > 1 ? 'en' : '';
          return textToDisplay + ' läuft in ' + leftDays + ' Tag' + plural + ' ab.';
        }
      }
      return null;
    } else {
      return null;
    }
  }
}

@Pipe({
  name: 'filterExpirePass'
})
export class FilterExpirePassPipe implements PipeTransform {
  constructor(private datesService: DatesService, private tmUserService: TmUserService) {
    // Empty
  }

  transform(passList: InstallerPassModel[], daysBefore?: number) {
    if (!passList) {
      return [];
    }

    return passList.filter(
      (x) =>
        (x.status == InstallerPassStatusEnum.Valid || x.status == InstallerPassStatusEnum.Expired) &&
        (this.datesService.dateIsExpired(x.expirationdate) ||
          this.tmUserService.calcDaysToRenew(x.expirationdate) < daysBefore)
    );
  }
}

@Pipe({
  name: 'requestStatusNameAndCss'
})
export class RequestStatusPipe implements PipeTransform {
  constructor(private metaService: MetaService) {
    // Empty
  }

  transform(status: string, type: string) {
    if (!status) {
      return type == 'css' ? '#c9c9c9' : '-';
    }
    const gridRegistrationStatusList = this.metaService.getRequestStatus();
    const idxStatus = gridRegistrationStatusList.findIndex((x) => x.value == status);
    if (idxStatus != -1) {
      return type == 'css'
        ? gridRegistrationStatusList[idxStatus].cssColor
        : gridRegistrationStatusList[idxStatus].displayName;
    } else {
      return type == 'css' ? '#c9c9c9' : status;
    }
  }
}

@Pipe({
  name: 'statusDisplayName'
})
export class StatusDisplayNamePipe implements PipeTransform {
  constructor(private metaService: MetaService) {
    // Empty
  }

  transform(status: string) {
    const option = this.metaService.getRequestStatus().find((x) => x.value === status);
    return option ? option.displayName : status;
  }
}
